import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Globe, Plus, ExternalLink, Sparkles, Layout, Store, Briefcase, Camera, Utensils, Wrench,
} from "lucide-react";

const templates = [
  {
    id: "premium",
    name: "Corporate Pro",
    desc: "Site vitrine professionnel et élégant",
    icon: Briefcase,
    gradient: "from-primary/20 to-primary/5",
    accent: "text-primary",
  },
  {
    id: "ecommerce",
    name: "E-Commerce",
    desc: "Boutique en ligne avec catalogue produits",
    icon: Store,
    gradient: "from-emerald-500/20 to-emerald-500/5",
    accent: "text-emerald-400",
  },
  {
    id: "portfolio",
    name: "Portfolio Créatif",
    desc: "Galerie visuelle pour artistes et créatifs",
    icon: Camera,
    gradient: "from-violet-500/20 to-violet-500/5",
    accent: "text-violet-400",
  },
  {
    id: "restaurant",
    name: "Restaurant & Food",
    desc: "Menu, réservation et ambiance culinaire",
    icon: Utensils,
    gradient: "from-orange-500/20 to-orange-500/5",
    accent: "text-orange-400",
  },
  {
    id: "saas",
    name: "SaaS & Tech",
    desc: "Landing page moderne pour produit tech",
    icon: Layout,
    gradient: "from-blue-500/20 to-blue-500/5",
    accent: "text-blue-400",
  },
  {
    id: "artisan",
    name: "Artisan & Services",
    desc: "Site local pour artisans et prestataires",
    icon: Wrench,
    gradient: "from-amber-500/20 to-amber-500/5",
    accent: "text-amber-400",
  },
];

export const WebsiteTab = () => {
  const navigate = useNavigate();
  const [siteUrl, setSiteUrl] = useState("");

  const handleConnect = () => {
    if (siteUrl.trim()) {
      // TODO: save connected site URL
      navigate("/parametres");
    }
  };

  return (
    <div className="space-y-5">
      {/* Connect existing site */}
      <div className="p-4 rounded-xl bg-secondary/30 border border-border/50 space-y-3">
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4 text-primary" />
          <span className="text-sm font-medium">Connecter un site existant</span>
        </div>
        <div className="flex gap-2">
          <Input
            value={siteUrl}
            onChange={(e) => setSiteUrl(e.target.value)}
            placeholder="https://mon-site.fr"
            className="flex-1 h-9 text-sm"
          />
          <Button
            variant="outline"
            size="sm"
            onClick={handleConnect}
            disabled={!siteUrl.trim()}
            className="gap-1.5 shrink-0"
          >
            <ExternalLink className="h-3.5 w-3.5" />
            Connecter
          </Button>
        </div>
      </div>

      {/* Create site CTA */}
      <Button
        variant="hero"
        className="w-full gap-2 h-11"
        onClick={() => navigate("/my-website")}
      >
        <Plus className="h-4 w-4" />
        Créer mon site avec Grafton IA
        <Sparkles className="h-4 w-4" />
      </Button>

      {/* Templates grid */}
      <div>
        <p className="text-xs text-muted-foreground mb-3 font-medium uppercase tracking-wider">
          Choisir un template
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {templates.map((t) => (
            <button
              key={t.id}
              onClick={() => navigate("/my-website")}
              className={`group relative p-3 rounded-xl border border-border/50 bg-gradient-to-br ${t.gradient} hover:border-primary/30 transition-all duration-200 text-left`}
            >
              <t.icon className={`h-5 w-5 ${t.accent} mb-2`} />
              <p className="text-xs font-semibold leading-tight">{t.name}</p>
              <p className="text-[10px] text-muted-foreground mt-0.5 leading-tight">{t.desc}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
